export function CustomActiveDot(props: any) {
  const { cx, cy, dataKey } = props
  const isCompoundLine = dataKey === 'Rastúce mesačné úročenie'

  if (isCompoundLine) {
    return (
      <circle
        cx={cx}
        cy={cy}
        r={6}
        fill="#50F000"
        stroke="white"
        strokeWidth={3}
      />
    )
  }
  return (
    <circle
      cx={cx}
      cy={cy}
      r={5}
      fill="white"
      stroke="#9ca3af"
      strokeWidth={2}
    />
  )
}
